// extracted by mini-css-extract-plugin
module.exports = {"youtube-video-in-popup":"youtube-video-in-popup__vho99"};